import React, {useEffect, useState} from 'react';
import {Button, Image } from "antd";
import './index.css'
import { useSelector,useDispatch } from 'react-redux';
import {setCurrencies} from "../../../../store/modules/user";

import {buyllm} from '../../../../api/other'
import {getWalletInfo} from "../../../../api/user";
//设置
const OpenCard =(props)=>{
    //父组件传输
    const {buyCardInfo,handleOk} = props
    const {currencies} = useSelector(state=>state.user)
    const dispatch = useDispatch()
    const [result,setResult] = useState(null)
    var isLoad = false
    useEffect(()=>{
        if(!isLoad){
            isLoad = true
            buyllm({product_id:buyCardInfo.product_id}).then(res=>{
                setResult(res)
                if(res.code === 200){
                    getWalletInfo().then(res=>{
                        if(res.code === 200){
                            dispatch(setCurrencies(res?.data?.currencies[0]))
                        }
                    })
                }
            })
        }
    },[])
    return (
        <div className="OpenCard">
            <div className='textCenter'>
                {
                    result?.msg?
                        <div className={'j_s'}>交易成功</div>:
                        <div className={'j_b'}>交易失败</div>
                }
                <Image src={buyCardInfo.product_image} width={200} preview={false}></Image>
                <div className={'j_d'}>
                    {result?.detail?result?.detail:''}
                </div>
                <div>
                    <Button className='selfBtn' onClick={handleOk}>
                        确定
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default OpenCard
